import type { AxiosError } from 'axios';

function readRequestIdHeader(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') return undefined;
  const response = (error as AxiosError).response;
  if (!response?.headers) return undefined;

  const headers = response.headers as Record<string, string | undefined>;
  const candidates = [
    headers['x-request-id'],
    headers['X-Request-Id'],
    headers['x-correlation-id'],
    headers['X-Correlation-Id'],
  ];

  return candidates.find((value) => typeof value === 'string' && value.trim().length > 0)?.trim();
}

/** ID discreto para suporte — header do backend ou fallback gerado no cliente. */
export function resolveSupportCode(error?: unknown): string {
  const fromHeader = error ? readRequestIdHeader(error) : undefined;
  if (fromHeader) return fromHeader;
  return `SP-${Date.now().toString(36).toUpperCase()}`;
}
